export function get(key, defaultValue = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return defaultValue;
    return JSON.parse(raw);
  } catch {
    return defaultValue;
  }
}

export function set(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function remove(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

// ── Schedule helpers ──

const SCHEDULE_KEY = 'crms.schedule';

export const DEFAULT_SCHEDULE = {
  version: 1,
  updatedAt: null,
  grade: 6,
  selections: {
    core: ['ela-6', 'math-6', 'science-6', 'social-studies-6'],
    pe: null,
    fineArts: [],
    electives: [],
  },
};

export function getSchedule() {
  const saved = get(SCHEDULE_KEY, null);
  if (!saved || typeof saved !== 'object' || saved.version !== 1) {
    return JSON.parse(JSON.stringify(DEFAULT_SCHEDULE));
  }
  return saved;
}

export function setSchedule(value) {
  return set(SCHEDULE_KEY, value);
}

export function clearSchedule() {
  return remove(SCHEDULE_KEY);
}

// ── Favorite clubs helpers ──

const FAVORITE_CLUBS_KEY = 'crms.favoriteClubs';

export function getFavoriteClubs() {
  const saved = get(FAVORITE_CLUBS_KEY, []);
  return Array.isArray(saved) ? saved : [];
}

export function toggleFavoriteClub(id) {
  const current = getFavoriteClubs();
  const next = current.includes(id)
    ? current.filter(cid => cid !== id)
    : [...current, id];
  set(FAVORITE_CLUBS_KEY, next);
  return next;
}

export function clearFavoriteClubs() {
  return remove(FAVORITE_CLUBS_KEY);
}
